import { render, staticRenderFns } from "./NavigationBanner.vue?vue&type=template&id=06d71b9a&scoped=true"
import script from "./NavigationBanner.vue?vue&type=script&lang=js"
export * from "./NavigationBanner.vue?vue&type=script&lang=js"
import style0 from "./NavigationBanner.vue?vue&type=style&index=0&id=06d71b9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d71b9a",
  null
  
)

export default component.exports